/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";

const StyledFormFieldsWrapper = styled.div`
  display: grid;
  gap: 16px;
  width: 100%;
`;

const FormFieldsWrapper = ({ children }) => {
  return <StyledFormFieldsWrapper>{children}</StyledFormFieldsWrapper>;
};

export default FormFieldsWrapper;
